import { settings } from '../settings'

export default {
  wrapper: {
    '& .a:hover': {
      fill: `${settings.theme.palette.primary.light}`,
    },
  },
}
